/**
 * Created by Languagenut on 18/04/2019.
 */


import React  from 'react';
import {ProgressBar} from 'react-bootstrap'
import {ProductService , ClassesService} from '../../../services';
import Translation from '../../../store/internationalization-store.js';

class UploadStudentsCompleted extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {
            errors:[],
            warnings:[],
            summary:[],
            loading:true
        };

        this.props.data.settings = {
            generateUsernames:false
        };
    }


    componentDidMount(){


        ClassesService.create(this.props.data.name , this.props.data.students  , this.props.data.allLanguages , this.props.data.selectedlanguages , this.props.data.sharedTeachers).then(function(uid){
            this.uid = uid;
            if (this.props.data.curriculumOptions != undefined) {
                ProductService.setAccountCurriculumsClass(this.props.data.curriculumOptions,this.uid)
                .then(function() {
                    window.location.hash = 'classes/students/'+this.uid+'/download';
                    this.setState({loading:false});
                }.bind(this))
            } else {
                window.location.hash = 'classes/students/'+this.uid+'/download';

                this.setState({loading:false});
            }
        }.bind(this));
    }


    render(){

        if(this.state.loading) return <ProgressBar animated now={100} />

        return null;
    }


}


export default {
    name: function() {return Translation.get('336' ,'Save' )},
    icon:<i class="fa-2x fas fa-save"></i>,
    title:null,
    onSubmit: function (done){
        done();
    },
    component: UploadStudentsCompleted
}